import { render, staticRenderFns } from "./ProductDescriptions.vue?vue&type=template&id=4025b961&scoped=true"
import script from "./ProductDescriptions.vue?vue&type=script&lang=js"
export * from "./ProductDescriptions.vue?vue&type=script&lang=js"
import style0 from "./ProductDescriptions.vue?vue&type=style&index=0&id=4025b961&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4025b961",
  null
  
)

export default component.exports